import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Popover from 'antd/lib/popover';
import Tabs from 'antd/lib/tabs';
import { Radio } from 'antd';
import { connect } from 'react-redux';
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import {
  formatDateTime,
} from '../../../common/utils/helpers';
import {
  createAccountMessageActions,
  selectMessagesFilter
} from '../../account-management/ducks';
import {
  fetchLoanAllMessagesActions,
  selectLoanAllMessages
} from '../ducks';

const mapStateToProps = state => ({
  messagesFilter: selectMessagesFilter(state),
  allMessages: selectLoanAllMessages(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchLoanAllMessages: fetchLoanAllMessagesActions.request,
      addAccountMessage: createAccountMessageActions.request,
    },
    dispatch
  ),
});


const TabPane = Tabs.TabPane;

@translate()
class CommunicationHelper extends Component {
  static propTypes = {
    loan: PropTypes.object,
    messagesFilter: PropTypes.array.isRequired,
  };

  componentDidMount(){
    
    this.setState({
      messages: this.props.loan.messages
    });
  }

  componentDidUpdate(props){
    if(this.props.loan.id !== props.loan.id){
        this.setState({
              messages: this.props.loan.messages
            });
    }
    
  }

  state = {
    editorState: EditorState.createEmpty(),
    messages: [],
    isExternal: false,
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  onCancel = () => {
    this.setState({
      editorState: EditorState.createEmpty()
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { editorState, isExternal } = this.state;
    const text = editorState.getCurrentContent();

    if (text.hasText()) {
      this.onSubmit({
        message: convertToRaw(text),
        isExternal
      });
      this.setState({
        editorState: EditorState.createEmpty()
      });
    }
  };

  onSubmit = message => {
    const { addAccountMessage , loan, messagesFilter, actions } = this.props;
    const accountId = loan.account.id;
    const newOne = actions.addAccountMessage({
      accountId,
      message,
      messagesFilter,
    });
    const transformedOne = {createdAt:new Date(),message:newOne.payload.message.message}
    const newMessages = this.state.messages;
    if (!message.isExternal) {
      newMessages.unshift(transformedOne);
    }
   
    this.setState({
      messages: newMessages,
      editorState: EditorState.createEmpty()
    });
    
  };

  onIsExternalChange = e => {
    this.setState({ isExternal: e.target.value });
  };

  callback = (key) => {
    if (key == 4) {
      const { loan, actions } = this.props;
      actions.fetchLoanAllMessages({
        loanId: loan.id,
      });
    }
  };
  
  render() {
    const { loan, t } = this.props;
    const { editorState, messages, isExternal } = this.state;
    const usedMessages = messages || [];
    let allCommunication = 0;
    if(this.props.allMessages) {
      if(this.props.allMessages.loanAllMessages) {
        if(this.props.allMessages.loanAllMessages.messages) {
          allCommunication = this.props.allMessages.loanAllMessages.messages
        }
      }
    }
    
    const content = (
    <div key={loan.id} id={loan.id}>
      <Tabs defaultActiveKey="1" onChange={this.callback} size='small'>
      <TabPane tab="Int. komunikácia" key="1">
        <div className="communicationPlaceholder">
        {usedMessages.map((value,index) => {
          return <div className="communicationPane" key={value.createdAt}>
                    <div>{formatDateTime(value.createdAt)}</div>
                    <div>{value.message.blocks[0].text}</div>
                </div>
        })}
        </div>
      </TabPane>
      <TabPane tab="Int. komunikácia k pôžičke" key="2">
      <div className="communicationPlaceholder">
        {usedMessages.map((value,index) => {
          if(new Date(value.createdAt)>new Date(loan.createdAt)){
            return <div className="communicationPane" key={value.createdAt}>
                    <div>{formatDateTime(value.createdAt)}</div>
                    <div>{value.message.blocks[0].text}</div>
                  </div>
          }
        })}
        </div>
      </TabPane>
      <TabPane tab="Všetka komunikácia" key="4">
        <div className="communicationPlaceholder">
          {
            !(allCommunication !== 0) ? <div></div> : 
              allCommunication.map((value, index) => {
                return <div className="communicationPane" key={value.createdAt}>
                         <div>{formatDateTime(value.createdAt)}</div>
                         <div>{value.message.blocks[0].text}</div>
                       </div>
              })
          }
        </div>
      </TabPane>
      <TabPane tab="Nový záznam" key="3">
        <Form onSubmit={this.handleSubmit}>
          <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={this.onEditorStateChange}
          />
          <div style={{ marginBottom: '30px' }}>
            <Radio.Group onChange={this.onIsExternalChange} value={isExternal}>
              <Radio value={false}>{t('Interná komunikácia')}</Radio>
              <Radio value={true}>{t('Externá komunikácia')}</Radio>
            </Radio.Group>
          </div>

          <Button size="default" type="primary" htmlType="submit">
            {t('Pridať')}
          </Button>
          <Button size="default" className="btn-inline" onClick={this.onCancel}>
            {t('Zmazať')}
          </Button>
        </Form>
      </TabPane>
    </Tabs>
    </div>
  );

    return (
        
        <Popover content={content} placement="bottomRight" title="Komunikácia" trigger="click">
          <span className="communicationMessage">
            <img src="/assets/singleMessage.svg"/>
          </span>
          <span className="numberOfLoans">{usedMessages.filter(p => new Date(p.createdAt)>new Date(loan.createdAt)).length}</span>
        </Popover>
        
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommunicationHelper);



// WEBPACK FOOTER //
// ./src/features/loan-management/components/CommunicationHelper.js